import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { ErrorListService } from './error-list.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-errorlist',
  imports: [MatIcon, TranslatePipe, AsyncPipe],
  templateUrl: './error-list.component.html',
  styleUrl: './error-list.component.scss',
})
export class ErrorListComponent {
  constructor(protected errorListService: ErrorListService) {}
}
